module.exports = __webpack_public_path__ + "static/login-poster-3cf283cd38708c192b50210e3f48c3e5.png";